import React from "react";

export default function Popup(props) {
  console.log("proporp", props.Flag);
  const popupClose = () => {
    window.location.reload();
  };
  return (
    <>
      <div className="popup_bg">
        <div className="popup_pos">
          <img src="/assets/images/check.svg" className="check_img" alt="" />
          <h5>
            {/* {props.Flag == 1
              ? "सफलतापूर्वक शामिल हो गए"
              : "पहले से ही सम्मिलित हैं"} */}
              {props?.msg}
          </h5>
          <button className="done_btn" onClick={() => popupClose()}>
            done
          </button>
        </div>
      </div>
    </>
  );
}
